<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CAlert
          v-if="reqResponse.message"
          class="mt-4"
          :color="reqResponse.type"
          :show="!!reqResponse.message"
        >
          {{ reqResponse.message }}
        </CAlert>
        <div class="mb-2">
          <LazyLoadSelect
            :classes="[
              {
                'is-invalid':
                  v$.form.first_user.$error ||
                  reqResponse.errors['first_user_id']
              },
              'mb-3'
            ]"
            :is-multiple="false"
            :selected="form.first_user"
            type="student"
            placeholder="Student A"
            @changed="
              (value) => {
                form.first_user = value
              }
            "
          >
            <template #footer>
              <div
                v-if="v$.form.$error && v$.form.first_user.required.$invalid"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div
                v-if="reqResponse.errors['first_user_id']"
                class="invalid-feedback"
              >
                {{ reqResponse.errors["first_user_id"][0] }}
              </div>
            </template>
          </LazyLoadSelect>

          <LazyLoadSelect
            :classes="[
              {
                'is-invalid':
                  v$.form.second_user.$error ||
                  reqResponse.errors['second_user_id']
              },
              'mb-3'
            ]"
            :is-multiple="false"
            :selected="form.second_user"
            type="student"
            placeholder="Student B"
            @changed="
              (value) => {
                form.second_user = value
              }
            "
          >
            <template #footer>
              <div
                v-if="v$.form.$error && v$.form.second_user.required.$invalid"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div
                v-if="v$.form.$error && !v$.form.second_user.notSameAsFrom"
                class="invalid-feedback"
              >
                Student B must be different
              </div>
              <div
                v-if="reqResponse.errors['second_user_id']"
                class="invalid-feedback"
              >
                {{ reqResponse.errors["second_user_id"][0] }}
              </div>
            </template>
          </LazyLoadSelect>

          <div class="form-group">
            <textarea
              v-model="form.message"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.message.$error || reqResponse.errors['message']
              }"
              placeholder="Admin only note"
              rows="5"
            />
            <div v-if="reqResponse.errors['message']" class="invalid-feedback">
              {{ reqResponse.errors["message"][0] }}
            </div>
          </div>

          <div class="form-group form-actions mt-4 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <div @click="submit()">
                <CLoadingButton
                  :spinner="isLoading"
                  :disabled="isLoading"
                  :loading="isLoading"
                  class="me-2 px-5 py-3 btn bg-gradient-blue text-white"
                >
                  Submit
                </CLoadingButton>
              </div>
              <router-link
                v-if="!isInView"
                class="text-graident-blue ms-3"
                to="/limits/ab-polarity"
              >
                <div class="d-flex align-items-center" @click="goToFullMenu()">
                  <img
                    width="18"
                    class="m-0 me-2"
                    src="@/assets/images/icons/gradient-link.png"
                  />
                  <span class="text-graident-blue">Go to full menu</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required, sameAs, not } from "vuelidate/lib/validators"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"

export default {
  name: "CreateABPolarityForm",
  components: { LazyLoadSelect },
  props: ["isInView"],
  emits: ["createPolarity", "closeModal"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      form: {
        first_user: [],
        second_user: [],
        message: ""
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      first_user: {
        required
      },
      second_user: {
        required,
        notSameAsFrom: not(sameAs("first_user"))
      },
      message: {}
    }
  },
  computed: {
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.v$.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(
        field.$invalid ||
        field.$model === "" ||
        this.reqResponse.errors[fieldName]
      )
    },
    submit() {
      this.resetResponseMessages()
      if (this.isValid) {
        const polarity = {
          first_user_id: this.form.first_user
            ? this.form.first_user.value.id
            : this.form.first_user,
          second_user_id: this.form.second_user
            ? this.form.second_user.value.id
            : this.form.second_user,
          status: false,
          message: this.form.message
        }
        this.isLoading = true
        this.$store
          .dispatch("polarities/createPolarity", polarity)
          .then(() => {
            this.resetForm()
            this.setSuccessResponse("Successfully created.")
            this.isLoading = false
            setTimeout(() => {
              this.resetResponseMessages()
              this.$emit("createPolarity")
            }, 1000)
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      } else {
        this.v$.$touch()
      }
    },
    resetForm() {
      this.v$.$reset()
      this.form = {
        first_user: [],
        second_user: [],
        message: ""
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    refreshForm() {
      this.resetForm()
      this.resetResponseMessages()
    },
    goToFullMenu() {
      this.$emit("closeModal")
    }
  }
}
</script>
